import { IconCollection } from "components/Icon/IconCollection";
import TableOptionMenu, { TableOption } from "./TableOptionMenu";

type TableGroupBySelectorProps<T extends string> = {
    value: T;
    options: TableOption<T>[];
    onChange: (value: T) => void;
};

/**
 * Toolbar control to pick how a table's rows are grouped. Uses the shared
 * {@link TableOptionMenu} (same look as the density selector); the caller owns
 * and persists the value and passes the matching `options.groupBy` to
 * RecordTable.
 */
function TableGroupBySelector<T extends string>({
    value,
    options,
    onChange,
}: TableGroupBySelectorProps<T>) {
    return (
        <TableOptionMenu
            icon={IconCollection.formatListBulletedType}
            label="Group rows"
            value={value}
            options={options}
            onChange={onChange}
            className="tableGroupBySelector"
        />
    );
}

export default TableGroupBySelector;
